export default __webpack_public_path__ + "static/media/usersImageDark.4bf6a24a.svg";